import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pie-chart",
  "use": "icon-pie-chart-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pie-chart\"><defs><style></style></defs><path d=\"M470 92v442.896c0 1.306.498 2.613 1.495 3.609a5.087 5.087 0 0 0 3.609 1.495h456.898c0 237.33-199.32 420-437.227 420C256.857 960 64 774.049 64 536.72 64 299.377 236.403 92 470.001 92H470zm56-28c237.904.001 434 182.67 434 420H531.103a5.089 5.089 0 0 1-3.608-1.494 5.087 5.087 0 0 1-1.496-3.609V64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol